import { createSlice, createAsyncThunk, combineReducers, configureStore } from '@reduxjs/toolkit';
import md5 from 'blueimp-md5';
import store, { ActionParams, methods, storageSlice, RootState } from '.';
import { UserAgent } from '@nyanyajs/utils/dist/userAgent';
import nyanyajs, { Debounce, NEventListener } from '@nyanyajs/utils';

// import { WebStorage } from './ws'
import { NoteItem } from './notes/typings';
import { storage } from './storage';
import { getI18n } from 'react-i18next';

import { api } from '../modules/electron/api';
import { stringify } from 'querystring';
import { resolve } from 'path';
import { nanoid } from 'nanoid';
import { client } from './sso';
import { alert, snackbar } from '@saki-ui/core';
import { t } from 'i18next';

export const modeName = 'user';

let timer: NodeJS.Timeout;

export type UserInfo = {
  uid: string;
  username: string;
  email: string;
  phone: string;
  nickname: string;
  avatar: string;
  bio: string;
  city: string[];
  gender: -1 | 1 | 2 | 3 | 4 | 5;
  birthday: string;
  status: -1 | 0 | 1;
  additionalInformation: {
    [k: string]: any;
  };
  appData: {
    [k: string]: any;
  };
  creationTime: number;
  lastUpdateTime: number;
  lastSeenTime: number;
};

export let userInfo: UserInfo = {
  uid: '',
  username: '',
  email: '',
  phone: '',
  nickname: '',
  avatar: '',
  bio: '',
  city: [],
  gender: -1,
  birthday: '',
  status: -1,
  additionalInformation: {},
  appData: {},
  creationTime: -1,
  lastUpdateTime: -1,
  lastSeenTime: -1,
};
export let userAgent = nyanyajs.userAgent(window.navigator.userAgent);

export const userSlice = createSlice({
  name: modeName,
  initialState: {
    userAgent: {
      ...userAgent,
    },
    token: '',
    deviceId: '',
    userInfo,
    isLogin: false,
    // -1 notLogin 0 Offline  1 Online
    status: -1 as 1 | 0 | -1,
    isInit: false,
    verifyAccountEventName: '',
  },
  reducers: {
    setInit: (state, params: ActionParams<boolean>) => {
      state.isInit = params.payload;
    },
    setStatus: (state, params: ActionParams<typeof state.status>) => {
      state.status = params.payload;

      // new Array(3).fill(0).some((_, status) => {
      //   if (state.status !== status && params.payload === status) {

      //   }

      // })
    },
    setVerifyAccountEventName: (state, params: ActionParams<string>) => {
      state.verifyAccountEventName = params.payload;
    },
    login: (
      state,
      params: ActionParams<{
        token: string;
        deviceId: string;
        userInfo: UserInfo;
      }>
    ) => {
      const { token, deviceId, userInfo } = params.payload;
      state.token = token || '';
      state.deviceId = deviceId || '';
      state.userInfo = userInfo || Object.assign({}, userInfo);
      state.isLogin = !!token;
      if (token) {
        storage.global.setSync('token', token);
        storage.global.setSync('deviceId', deviceId);
        storage.global.setSync('userInfo', userInfo);
      }
      // store.dispatch(userSlice.actions.init({}))
    },
    logout: (state, _) => {
      storage.global.delete('token');
      storage.global.delete('deviceId');
      storage.global.delete('userInfo');
      state.token = '';
      state.deviceId = '';
      state.userInfo = Object.assign({}, userInfo);
      state.isLogin = false;
      state.status = -1;
    },
  },
});

export const userMethods = {
  Init: createAsyncThunk<
    void,
    void,
    {
      state: RootState;
    }
  >(modeName + '/Init', async (_, thunkAPI) => {
    // 获取配置
    // console.log(await storage.config.get('language'))
    // thunkAPI.dispatch(userSlice.actions.setInit(false))
    const { user, config } = thunkAPI.getState();
    console.log('校验token是否有效');
    const token = await storage.global.get('token');
    const deviceId = await storage.global.get('deviceId');
    const userInfo = await storage.global.get('userInfo');

    if (token) {
      thunkAPI.dispatch(
        userSlice.actions.login({
          token: token,
          deviceId: deviceId,
          userInfo: userInfo,
        })
      );
      // 检测网络状态情况
      await thunkAPI
        .dispatch(
          methods.user.checkToken({
            token,
            deviceId,
          })
        )
        .unwrap();
    } else {
      thunkAPI.dispatch(userSlice.actions.logout({}));
    }
    thunkAPI.dispatch(userSlice.actions.setInit(true));
  }),
  checkToken: createAsyncThunk(
    modeName + '/checkToken',
    async (
      {
        token,
        deviceId,
      }: {
        token: string;
        deviceId: string;
      },
      thunkAPI
    ) => {
      try {
        const res = await client?.checkToken({
          token: token,
          deviceId,
        });
        console.log('res checkToken', res);
        if (res) {
          thunkAPI.dispatch(userSlice.actions.setStatus(1));
          // console.log('登陆成功')
          thunkAPI.dispatch(
            userSlice.actions.login({
              token: res.token,
              deviceId: res.deviceId,
              userInfo: res.userInfo,
            })
          );
          thunkAPI.dispatch(userSlice.actions.setStatus(1));
        } else {
          thunkAPI.dispatch(userSlice.actions.logout({}));
        }
        clearTimeout(timer);
      } catch (error) {
        console.error(error);
        const { user } = store.getState();

        console.log('res checkToken', user.status);
        if (user.status !== 0) {
          snackbar({
            message: t('userOffline', {
              ns: 'sakiuiPrompt',
            }),
            horizontal: 'center',
            vertical: 'top',
            autoHideDuration: 2000,
            color: '#fff',
            backgroundColor: 'var(--saki-default-color)',
          }).open();
        }

        thunkAPI.dispatch(userSlice.actions.setStatus(0));
        timer = setTimeout(async () => {
          await thunkAPI
            .dispatch(
              methods.user.checkToken({
                token,
                deviceId,
              })
            )
            .unwrap();
        }, 5 * 1000);
      }
    }
  ),
  login: createAsyncThunk(
    modeName + '/login',
    async (
      {
        token,
        deviceId,
        userInfo,
      }: {
        token: string;
        deviceId: string;
        userInfo: UserInfo;
      },
      thunkAPI
    ) => {
      thunkAPI.dispatch(userSlice.actions.setStatus(1));
      thunkAPI.dispatch(
        userSlice.actions.login({
          token,
          deviceId,
          userInfo,
        })
      );
      snackbar({
        message: t('loginSuccessfully', {
          ns: 'sakiuiPrompt',
        }),
        horizontal: 'center',
        vertical: 'top',
        autoHideDuration: 2000,
        color: '#fff',
        backgroundColor: 'var(--saki-default-color)',
      }).open();
    }
  ),
  logout: createAsyncThunk(modeName + '/logout', async (_, thunkAPI) => {
    alert({
      title: t('logout', {
        ns: 'sakiuiPrompt',
      }),
      content: t('logoutContent', {
        ns: 'sakiuiPrompt',
      }),
      cancelText: t('cancel', {
        ns: 'sakiuiPrompt',
      }),
      confirmText: t('logout', {
        ns: 'sakiuiPrompt',
      }),
      onCancel() {},
      onConfirm() {
        thunkAPI.dispatch(userSlice.actions.logout({}));
        snackbar({
          message: t('logoutSuccessfully', {
            ns: 'sakiuiPrompt',
          }),
          horizontal: 'center',
          vertical: 'top',
          autoHideDuration: 2000,
          color: '#fff',
          backgroundColor: 'var(--saki-default-color)',
        }).open();
      },
    }).open();
  }),
};
